import "@fontsource/quattrocento/400.css";
import "@fontsource/quattrocento/700.css";
import "@fontsource/quattrocento-sans/400.css";
import "@fontsource/quattrocento-sans/700.css";
import "@fontsource/inconsolata/500.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initAnalytics } from "./lib/analytics";
import "./styles.css";

initAnalytics();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
